import { MenuItem, Select, Stack } from '@mui/material';

import { RHFSelect, RHFTextField } from '@Components/hook-form';
import { AtLocator } from '@Components/shared/locators/AtLocator';

// Styles
import Styles from './CreateProviderContent.module.scss';
import { useGeneral } from '@Modal/hooks/general/useGeneral';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';

export const CreateProviderContent = () => {
  const { rgs, handleRgsChange } = useGeneral();
  const { currentUser } = useAuthorization();

  const rgsForAdmin = ['EU', 'EU2', 'AS', 'AS1', 'SA', 'AF', 'AF1', 'AF2', 'AF3'];
  const isSuper = currentUser?.isSuper;
  const userRgsIds = currentUser?.rgsIds || [];

  const options = isSuper ? rgsForAdmin : userRgsIds;

  return (
    <Stack className={Styles.CreateProviderContent}>
      <Select defaultValue={rgs || 'EU'}>
        {options.map((region) => (
          <MenuItemEx
            key={region}
            name={region}
            value={region}
            // @ts-ignore
            onClick={() => handleRgsChange(region)}
          >
            {region}
          </MenuItemEx>
        ))}
      </Select>
      <AtLocator type="text-field" name="name" key="name">
        <RHFTextField name="name" label="Name" />
      </AtLocator>
      <AtLocator type="text-field" name="apiUrl" key="apiUrl">
        <RHFTextField name="apiUrl" label="Api Url" />
      </AtLocator>
      <RHFSelect label="Status" name="status" variant="outlined">
        <MenuItem value="ACTIVE">Active</MenuItem>
        <MenuItem value="INACTIVE">Inactive</MenuItem>
      </RHFSelect>
      <RHFSelect label="Is Internal" name="isInternal" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Sync Round End" name="syncRoundEnd" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect
        label="Retry Scheduled Send Credit"
        name="retryScheduledSendCredit"
        variant="outlined"
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Refund On Credit Fail" name="refundOnCreditFail" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect
        label="Filter External Provider Bets"
        name="filterExternalProviderBets"
        variant="outlined"
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Integration Type" name="integrationType" variant="outlined">
        <MenuItem value="DIRECT">DIRECT</MenuItem>
        <MenuItem value="REVERSE_BGI">REVERSE_BGI</MenuItem>
      </RHFSelect>
      <RHFSelect label="Raindrop Creation Notification" name="syncRaindrop" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Freebet Creation Notification" name="syncFreebet" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Notify On Last Freebet" name="notifyOnLastFreebet" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Enable Inactivity Screen" name="enableInactivityScreen" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Raindrop Type" name="raindropType" variant="outlined">
        <MenuItem value="RAINDROP_QUEUE">Queue</MenuItem>
        <MenuItem value="RAINDROP_MULTIVIEW">Multiview</MenuItem>
      </RHFSelect>
    </Stack>
  );
};
